import React from 'react';
import { Box, Typography } from '@mui/material';

const Profile = () => {
  return (
    <Box>
      <Box sx={{ mb: 4 }}>
        <Typography variant="h4" sx={{ color: '#ffffff', fontWeight: 700, mb: 1 }}>
          Profile
        </Typography>
        <Typography variant="body1" sx={{ color: '#b0b0b0' }}>
          Manage your account settings and preferences
        </Typography>
      </Box>
      
      <Box sx={{ textAlign: 'center', py: 8 }}>
        <Typography variant="h6" sx={{ color: '#b0b0b0', mb: 2 }}>
          User Profile
        </Typography>
        <Typography variant="body2" sx={{ color: '#666666' }}>
          This component will allow users to view and edit their profile information and account settings.
        </Typography>
      </Box>
    </Box>
  );
};

export default Profile; 